import { render } from "./PaymentModalPage.vue?vue&type=template&id=58f96bc1&lang=true"
import script from "./PaymentModalPage.vue?vue&type=script&lang=js"
export * from "./PaymentModalPage.vue?vue&type=script&lang=js"

import "./PaymentModalPage.vue?vue&type=style&index=0&id=58f96bc1&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__